export default "__VITE_ASSET__851ede36__"